const cleanupNumber = (val, caret) => {
    if (['.', ',', '-.', '-,'].indexOf(val) >= 0) {
        return {value: "", caret: 0}
    }
    let originalCaret = caret;
    let ret = [];
    let wasComa = false;
    for (let i = 0; i < val.length; i++) {
        const char = val.charAt(i);
        if (i === 0 && ["+", "-"].indexOf(char) >= 0) {
            if (val.length === 1) {
                ret.push('-');
                continue;
            }
            ret.push(char);
            continue;
        }
        if (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].indexOf(char) >= 0) {
            ret.push(char);
            continue;
        }
        if (!wasComa && [".", ","].indexOf(char) >= 0) {
            wasComa = true;
            ret.push('.');
            continue;
        }
        if (i <= originalCaret) {
            caret--;
        }
    }
    if (ret.length === 0) {
        return {value: "", caret: 0}
    }
    if (ret.length === 1 && ret[0] === '-') {
        return {value: "-", caret: originalCaret === 0 ? 0 : 1}
    }
    originalCaret = caret;
    const num = Number.parseFloat(ret.join(""));
    const number = num.toString().replace('.', ',');
    let dotIndex = number.indexOf(',');
    if (dotIndex < 0) {
        dotIndex = number.length;
    }
    const appendix = number.substring(dotIndex);

    let decimalCounter = 0;
    ret = appendix;
    for (let i = dotIndex - 1; i >= 0; i--) {
        ret = number.charAt(i) + ret;
        if (decimalCounter++ % 3 === 2) {
            if (i !== 0 && !(i === 1 && number[0] === '-')) {
                if (i <= originalCaret) {
                    caret++;
                }
                ret = " " + ret;
            }
        }
    }

    const endsWithComa = val.endsWith(".") || val.endsWith(",");
    return {value: ret + ((ret.indexOf(',') < 0 && endsWithComa) ? "," : ""), caret, num};
};


if (!customElements.get('cian-moblie-input-with-slider')) customElements.define('cian-moblie-input-with-slider', class extends HTMLElement {
    static get observedAttributes() {
        return ['slider-value', 'slider-min', 'slider-max', 'slider-step'];
    }

    attributeChangedCallback(name, old, _new) {
        if (old !== _new) {
            this.updateValue();
        }
    }

    getNumAttr(name, defaut) {
        if (this.hasAttribute(name)) {
            return Number.parseFloat(this.getAttribute(name));
        }
        return defaut;
    }

    constructor() {
        super();
    }

    connectedCallback() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init());
        }
        else {
            this.init()
        }
    }

    init() {
        document.addEventListener('cian-focus', (e) => {
            if (e.target === this) {
                this.querySelector('[relative]').style.border = computedStyle.getPropertyValue("--cian-focus-border") || 'none';
            }
            else {
                this.querySelector('[relative]').style.border = computedStyle.getPropertyValue("--cian-border") || 'none';
            }
        });
        document.addEventListener('cian-blur', (e) => {
            if (e.target === this) {
                this.querySelector('[relative]').style.border = computedStyle.getPropertyValue("--cian-border") || 'none';
            }
        });
        const addorment = this.querySelector('[addorment]');
        const leftPaddingInput = this.getAttribute('input-left-padding') || '0';
        const computedStyle = window.getComputedStyle(this);
        this.pipkaVisibility = computedStyle.getPropertyValue("--cian-ico-visibility") || 'visible';
        this.innerHTML = `
                <div relative style="user-select: none; box-sizing: border-box; position: relative; width: 100%; 
                    border: ${computedStyle.getPropertyValue("--cian-border") || 'none'}; 
                    border-radius: ${computedStyle.getPropertyValue("--cian-border-radius") || 'none'}; 
                    padding: ${computedStyle.getPropertyValue("--cian-padding") || 'none'}
                    ">
                    <div class="cian-input-wrapper">
                        <div display style="box-sizing: border-box; width: auto; padding-left: ${leftPaddingInput}"></div>
                    </div>
                    <div slider class="cian-pipka-line">
                        <div class="cian-pipka"></div>                                                                  
                    </div>
                    <div input style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; visibility: hidden">
                        <input type="tel" style="box-sizing: border-box;    width: 100%; height: 100%; outline: none; border: none; vertical-align: center; padding: ${computedStyle.getPropertyValue("--cian-padding") || 'none'}; background: white; font: inherit;"/>
                    </div>
                    <svg ico style="right: 16px; top: calc(50% - 4px); position: absolute; visibility: ${this.pipkaVisibility}" width="36" height="8" viewBox="0 0 36 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.646447 3.64645C0.451184 3.84171 0.451184 4.15829 0.646447 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646447 3.64645ZM8 3.5H1V4.5H8V3.5Z" fill="#262C40"/>
                        <circle cx="11" cy="4" r="1" fill="#262C40"/>
                        <circle cx="15" cy="4" r="1" fill="#262C40"/>
                        <path d="M35.3536 4.35355C35.5488 4.15829 35.5488 3.84171 35.3536 3.64645L32.1716 0.464466C31.9763 0.269204 31.6597 0.269204 31.4645 0.464466C31.2692 0.659728 31.2692 0.976311 31.4645 1.17157L34.2929 4L31.4645 6.82843C31.2692 7.02369 31.2692 7.34027 31.4645 7.53553C31.6597 7.7308 31.9763 7.7308 32.1716 7.53553L35.3536 4.35355ZM28 4.5H35V3.5H28V4.5Z" fill="#262C40"/>
                        <circle r="1" transform="matrix(-1 0 0 1 25 4)" fill="#262C40"/>
                        <circle r="1" transform="matrix(-1 0 0 1 21 4)" fill="#262C40"/>
                    </svg>

                </div>
                <style>
                    .cian-input-wrapper {
                        display: flex;
                    }
                    .cian-pipka-line {
                        z-index: 1;
                        box-sizing: border-box;
                        position: absolute;
                        top: 0;
                        left: -1px;
                        height: calc(100% + 3px);
                        width: 0;
                        background: ${computedStyle.getPropertyValue("--cian-color") || 'black'};
                        border-bottom: solid 1px ${computedStyle.getPropertyValue("--cian-pipka-line") || 'red'}
                    }
                    .cian-pipka {
                        cursor: ${computedStyle.getPropertyValue("--cian-pipka-hover") || 'auto'};
                        position: absolute;
                        bottom: -7px; right: -8px; width: 13px; height: 13px; border-radius: 50%; 
                        border: ${computedStyle.getPropertyValue("--cian-pipka-border") || '1px solid white'}; 
                        box-sizing: ${computedStyle.getPropertyValue("--cian-pipka-shaddow") || 'none'};
                        background: ${computedStyle.getPropertyValue("--cian-pipka-bg") || 'yellow'}
                    }
                </style>
        `;
        const display = this.querySelector('[display]');
        if(addorment) {
            display.parentNode.appendChild(addorment);
        }
        const inputElement = this.querySelector('input');
        const inputHandler = () => {
            let {value, caret, num} = cleanupNumber(inputElement.value, inputElement.selectionStart);
            inputElement.value = value;
            inputElement.setSelectionRange(caret, caret);
            if(num < this.getMin()) {
                const customEvent = new CustomEvent('change-value', {bubbles: true});
                customEvent.value = this.getMin();
                inputElement.dispatchEvent(customEvent);
            }
            else if(num > this.getMax()) {
                const customEvent = new CustomEvent('change-value', {bubbles: true});
                customEvent.value = this.getMax();
                inputElement.dispatchEvent(customEvent);
            }
            else {
                const customEvent = new CustomEvent('change-value', {bubbles: true});
                customEvent.value = num;
                inputElement.dispatchEvent(customEvent);
            }
        };
        inputElement.addEventListener('focus', () => {
            this.querySelector('[slider]').style.visibility = 'hidden';
            this.querySelector('[ico]').style.visibility = 'hidden';
            this.dispatchEvent(new CustomEvent('cian-focus', {bubbles: true}));
            inputElement.value = this.getNumAttr('slider-value');
            inputHandler();
        });
        inputElement.addEventListener('input', inputHandler);
        inputElement.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === 'Escape' || event.key === 'Esc') {
                this.querySelector('[slider]').style.visibility = 'visible';
                this.querySelector('[ico]').style.visibility = this.pipkaVisibility;
                this.querySelector('[input]').style.visibility = 'hidden';
                event.preventDefault();
            }
        });
        inputElement.addEventListener('blur', () => {
            this.querySelector('[slider]').style.visibility = 'visible';
            this.querySelector('[ico]').style.visibility = this.pipkaVisibility;
            this.querySelector('[input]').style.visibility = 'hidden';
            this.dispatchEvent(new CustomEvent('cian-blur', {bubbles: true}));
        });
        this.addEventListener('click', () => {
            if(!wasMove) {
                this.querySelector('[input]').style.visibility = 'visible';
                inputElement.focus();
            }
        });

        let moveStart;
        let startValue;
        let wasMove = false;
        const startHandler = ev => {
            wasMove = false;
            if (ev.buttons && ev.offsetX >= -8 && ev.offsetX <= this.getBoundingClientRect().width + 8) {
                // this.dispatchEvent(new CustomEvent('cian-focus', {bubbles: true}));
                moveStart = ev.offsetX;
                startValue = this.getValue();
            }
        };
        const endHandler = ev => {
            if(wasMove) {
                ev.stopPropagation();
                ev.preventDefault();
            }
            moveStart = false;
            // this.dispatchEvent(new CustomEvent('cian-blur', {bubbles: true}));
        };
        const moveHandler = ev => {
            wasMove = true;
            if (moveStart && ev.buttons && ev.offsetX >= -8 && ev.offsetX <= this.getBoundingClientRect().width + 8) {
                const percent = (ev.offsetX - moveStart) / this.getBoundingClientRect().width;
                const rawDelta = percent * (this.getMax() - this.getMin());
                const alignedValue = startValue + Math.round(rawDelta / this.getStep()) * this.getStep();
                this.setAttribute('slider-value', alignedValue);
            }
        };
        const relative = this.querySelector('[relative]');
        document.addEventListener('mousemove', e => {
            moveHandler({
                buttons: e.buttons,
                offsetX: e.pageX - this.getBoundingClientRect().x
            })
        });
        document.addEventListener('touchmove', (e) => {
            const touch = e.changedTouches[0];
            touch.buttons = true;
            touch.offsetX = touch.pageX - relative.getBoundingClientRect().x;
            moveHandler(touch);
        });
        this.addEventListener('mousedown', e => {
            startHandler({
                buttons: e.buttons,
                offsetX: e.pageX - this.getBoundingClientRect().x
            });
        });
        this.addEventListener('touchend', endHandler);
        this.addEventListener('touchcancel', endHandler);
        this.addEventListener('mouseup', endHandler);
        document.addEventListener('touchend', () => {moveStart = false;});
        document.addEventListener('touchcancel', () => {moveStart = false;});
        document.addEventListener('mouseup', () => {moveStart = false;});
        this.addEventListener('touchstart', (e) => {
            const touch = e.changedTouches[0];
            touch.buttons = true;
            touch.offsetX = touch.pageX - relative.getBoundingClientRect().x;
            startHandler(touch);
        });

        this.addEventListener('change-value', (e) => {
            if (e.target === inputElement) {
                this.setAttribute('slider-value', e.value);
            }
            this.querySelectorAll('[value]').forEach(v => v.setAttribute('value', e.value));
        });

        this.updateValue();
    }

    getStep() {
        return this.getNumAttr('slider-step') || 1;
    }

    getMax() {
        return this.getNumAttr('slider-max') || 100;
    }

    getMin() {
        return this.getNumAttr('slider-min') || 0;
    }

    getValue() {
        return this.getNumAttr('slider-value') || 0;
    }

    updateValue() {
        const display = this.querySelector('[display]');
        const slider = this.querySelector('[slider]');
        const oldValue = this.getValue();
        if (display && slider) {
            const value = Math.min(Math.max(this.getMin(), oldValue), this.getMax());
            if (oldValue !== value) {
                this.setAttribute('slider-value', value);
                return;
            }
            const {value: num} = cleanupNumber("" + value, 0);
            display.innerHTML = num;
            slider.style.width = `calc(${(value - this.getMin()) / (this.getMax() - this.getMin()) * 100}% + 1px)`;
            const event = new CustomEvent('change-value');
            event.value = value;
            this.dispatchEvent(event);
            if(this.hasAttribute('custom-event')) {
                const customEvent = new CustomEvent(this.getAttribute('custom-event'), {bubbles: true});
                customEvent.value = value;
                this.dispatchEvent(customEvent)
            }
        }
    }
});
